import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Pipe({ name: 'labelRequired' })
export class LabelRequirednPipe implements PipeTransform {
  constructor() {}

  transform(value: any, field: string, formgroup: UntypedFormGroup): string {
    if (value && field && formgroup) {
      const form_field = formgroup.get(field);
      if (form_field.validator) {
        const validator = form_field.validator({} as AbstractControl);
        const required = validator && validator.required;
        if (!required) {
          return `${value} (optioneel)`;
        }
      } else {
        return `${value} (optioneel)`;
      }

      return value;
    }
  }
}
